<template>
  <div class="address-form-container">
    <div :class="{ 'span-2': isCheckOutPage }">
      <v-autocomplete
        v-model="localSelected"
        :items="addressOptions"
        :filter="handleSearch"
        :return-object="true"
        :hide-details="true"
        color="primary"
        ref="search"
        item-value="id"
        placeholder="ค้นหารหัสไปรษณีย์ เพื่อกรอกจังหวัด เขต/อำเภอ แขวง/ตำบล"
        class="text-sm"
        append-icon=""
        prepend-inner-icon="mdi-magnify"
        oninput="this.value=this.value.slice(0,5).replace(/[^\d]+/g, '')"
        inputmode="numeric"
        outlined
        background-color="white"
        @change="handleSelected"
      >
        <template v-slot:no-data>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="text-sm">
                ไม่พบข้อมูล
                กรุณาระบุและตรวจสอบรหัสไปรษณีย์ของคุณให้ถูกต้อง
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-autocomplete>
    </div>

    <div v-if="!isCheckOutPage" class="w-full"></div>

    <div>
      <v-autocomplete
        v-model="localProvince"
        color="primary"
        :items="provinceOptions"
        :error="errorProvince"
        ref="province"
        class="text-sm"
        background-color="white"
        label="จังหวัด"
        placeholder="จังหวัด"
        outlined
        hide-details
        @change="handleProvinceChange"
      ></v-autocomplete>
    </div>

    <div>
      <v-autocomplete
        v-model="localDistrict"
        :items="districtOptions"
        color="primary"
        :error="errorDistrict"
        ref="district"
        class="text-sm"
        background-color="white"
        label="เขต/อำเภอ"
        placeholder="เลือกเขต/อำเภอ"
        outlined
        hide-details
        @change="handleDistrictChange"
      ></v-autocomplete>
    </div>

    <div>
      <v-autocomplete
        v-model="localSubDistrict"
        :items="subDistrictOptions"
        color="primary"
        :error="errorSubDistrict"
        ref="subDistrict"
        class="text-sm"
        background-color="white"
        label="แขวง/ตำบล"
        placeholder="เลือกแขวง/ตำบล"
        outlined
        hide-details
        @change="emitChange('subDistrict', localSubDistrict)"
      ></v-autocomplete>
    </div>

    <div>
      <v-text-field
        v-model="localPostcode"
        color="primary"
        :error="errorPostcode"
        ref="postcode"
        type="text"
        label="รหัสไปรษณีย์"
        placeholder="รหัสไปรษณีย์"
        class="text-sm"
        oninput="this.value=this.value.slice(0,5).replace(/[^\d]+/g, '')"
        inputmode="numeric"
        outlined
        hide-details
        @change="emitChange('postcode', localPostcode)"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selected: {
      type: Object,
      default: null,
    },
    postcode: {
      type: String,
      default: '',
    },
    province: {
      type: String,
      default: '',
    },
    district: {
      type: String,
      default: '',
    },
    subDistrict: {
      type: String,
      default: '',
    },

    errorPostcode: {
      type: Boolean,
      default: false,
    },
    errorProvince: {
      type: Boolean,
      default: false,
    },
    errorDistrict: {
      type: Boolean,
      default: false,
    },
    errorSubDistrict: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      localSelected: null,

      localPostcode: this.postcode.toString(),
      localProvince: this.province,
      localDistrict: this.district,
      localSubDistrict: this.subDistrict,

      isCheckOutPage: this.$route.name === 'Cart',
    }
  },

  computed: {
    addressOptions() {
      return this.$store.getters[
        'thailandStore/addressSelectionByPostcode'
      ]
    },
    provinceOptions() {
      return this.$store.getters['thailandStore/fetchProvince']
    },
    districtOptions() {
      return this.$store.getters['thailandStore/fetchDistrict'](
        this.localProvince,
      )
    },
    districtOptionsTotal() {
      return this.districtOptions.length
    },
    subDistrictOptions() {
      return this.$store.getters['thailandStore/fetchSubDistrict'](
        this.localProvince,
        this.localDistrict,
      )
    },
    subDistrictOptionsTotal() {
      return this.subDistrictOptions.length
    },
  },

  watch: {
    postcode(value) {
      this.localPostcode = value.toString()
    },
    province(value) {
      this.localProvince = value
    },
    district(value) {
      this.localDistrict = value
    },
    subDistrict(value) {
      this.localSubDistrict = value
    },
  },

  methods: {
    handleSearch(item, queryText) {
      if (!queryText) {
        return false
      }

      return item.postcode
        .toString()
        .toLowerCase()
        .includes(queryText.toLowerCase())
    },
    handleSelected(value) {
      if (!value) {
        return
      }

      if (value) {
        this.localPostcode = value.postcode.toString()
        this.localProvince = value.province
        this.localDistrict = value.district
        this.localSubDistrict = value.subDistrict
      } else {
        this.localPostcode = ''
        this.localProvince = ''
        this.localDistrict = ''
        this.localSubDistrict = ''
      }

      this.emitChange('postcode', this.localPostcode)
      this.emitChange('province', this.localProvince)
      this.emitChange('district', this.localDistrict)
      this.emitChange('subDistrict', this.localSubDistrict)

      this.$nextTick(() => {
        this.localSelected = null
        this.$refs.search.blur()

        // scroll to the province field
        this.$refs.province.$el.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        })
      })
    },
    handleProvinceChange(value) {
      this.localDistrict = ''
      this.localSubDistrict = ''
      this.localPostcode = ''

      this.emitChange('province', value)
      this.emitChange('district', '')
      this.emitChange('subDistrict', '')
      this.emitChange('postcode', '')
    },
    handleDistrictChange(value) {
      this.localSubDistrict = ''
      this.localPostcode = ''

      this.emitChange('district', value)
      this.emitChange('subDistrict', '')
      this.emitChange('postcode', '')
    },
    handleSubDistrictChange(value) {
      this.localPostcode = ''

      this.emitChange('subDistrict', value)
      this.emitChange('postcode', '')
    },
    emitChange(field, value) {
      this.$emit(`update:${field}`, value)
    },
  },
}
</script>

<style lang="stylus" scoped>
.address-form-container {
    display: grid
    grid-template-columns: repeat(1, 1fr)
    gap 21px 14px

    .span-2 {
        grid-column: span 1

        @media screen and (min-width: 768px){
            grid-column: span 2
        }
    }

    @media screen and (min-width: 768px){
        grid-template-columns: repeat(2, 1fr)
    }
}

::v-deep .v-list-item__title
  white-space: normal
</style>
